import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useForm } from "react-hook-form";
import { addProductToList } from "../../service/api";
import IProduct from '../../types/IProduct';
import {ButtonContainer} from '../PickList/stylesPickList';
import { AddNewProductContainer } from './stylesAddNewProduct';

export default function AddNewProductToList(props: { id: string }) {

    //Modal Hooks
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // React Hook Form
    const { register, handleSubmit, reset } = useForm();
    const onSubmit = (data:any) => {
        saveNewProduct(data);
    }

    function saveNewProduct(data: {name: string, price: string, quantities: string, unities: string}) {
        const newProduct: IProduct = {
            name: data.name,
            price: data.price,
            quantities: Number(data.quantities),
            unities: Number(data.unities),
            checked: false
        };
        addProductToList(props.id, newProduct);
        reset();
        handleClose();
        
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Adicionar Produto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddNewProductContainer>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <h4 >Nome: </h4>
                        <input placeholder='Insira o nome do produto'  {...register("name", {required: true})} />
                        <h4 >Preço: </h4>
                        <input placeholder='Insira o preço do produto' type="number" step="any"{...register("price")} />
                        <h4>Quantidade g/ml:</h4>
                        <input placeholder='Insira a quantidade em g ou ml' type="number" {...register("quantities")} />
                        <h4>Unidades:</h4>
                        <input placeholder='Insira o número de unidades' type="number" {...register("unities")} />
                        <br></br>
                        <Button type="submit" variant="primary" >Salvar novo produto</Button>
                        <Button variant="danger" onClick={handleClose}>
                            Fechar
                        </Button>
                    </form>
                    </AddNewProductContainer>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>

            <ButtonContainer>

                <Button onClick={handleShow} variant="success">Adicionar produto</Button>
            </ButtonContainer>

        </>
    );
}